import { render, staticRenderFns } from "./FilterDeliveryList.vue?vue&type=template&id=0542a5f8&"
import script from "./FilterDeliveryList.vue?vue&type=script&lang=js&"
export * from "./FilterDeliveryList.vue?vue&type=script&lang=js&"
import style0 from "./FilterDeliveryList.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports